import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionLabel } from '../SectionLabel';
import { CtaButton } from '../CtaButton';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-cream px-4 py-12 sm:px-6 sm:py-20" data-id="element-85" data-mp="26mmcgnkob7lb">
      <div className="mx-auto max-w-5xl" data-id="element-86" data-mp="22lspbwf21wth">
        <div className="text-center" data-id="element-87" data-mp="22ioewhazy4ud">
          <SectionLabel data-id="element-88" data-mp="2zbjt6m98kwby">Prima e dopo</SectionLabel>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-[1.15] text-navy-deep sm:text-4xl md:text-[42px]" data-id="element-89" data-mp="2za8o8j421ij9">
            Smetti di improvvisare davanti a una creatinina elevata
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-navy/75 sm:text-lg" data-id="element-90" data-mp="2qc6i5p5grzp4">
            Inizia a decidere come se avessi un nefrologo al tuo fianco durante ogni
            visita.
          </p>
        </div>

        <div className="mt-8 grid gap-5 sm:mt-12 sm:grid-cols-2 sm:gap-6" data-id="element-91" data-mp="19vke6oixscoe">
          {/* PRIMA */}
          <div className="flex flex-col rounded-3xl border border-navy-deep/10 bg-white p-5 sm:p-7" data-id="element-92" data-mp="174ulet3btb4t">
            <div className="flex items-center gap-2.5" data-id="element-93" data-mp="1c4p9kovpvmm6">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-alert/10" data-id="element-94" data-mp="1c2cr8am1ra8l">
                <XIcon className="h-4 w-4 text-alert" aria-hidden="true" data-id="element-95" data-mp="y6se5vt01m93" />
              </span>
              <div data-id="element-96" data-mp="135vfb55uz8bs">
                <p className="text-[10.5px] font-extrabold uppercase tracking-[0.18em] text-alert" data-id="element-97" data-mp="oeuz2dyvea53">
                  Prima
                </p>
                <h3 className="font-display text-xl font-bold text-navy-deep sm:text-2xl" data-id="element-98" data-mp="t6d0120w8aq2">
                  Decidi con incertezza
                </h3>
              </div>
            </div>

            <ul className="mt-5 flex flex-col gap-3.5" data-id="element-99" data-mp="jgtgdu5cwcu5">
              {beforeItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-100" data-mp="5h1w5bo8y07p">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert/70" aria-hidden="true" data-id="element-101" data-mp="af3nejvtt5u9" />
                  <span className="text-[14px] leading-relaxed text-navy/80" data-id="element-102" data-mp="2c52fzkrbnkzz">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-auto pt-6" data-id="element-103" data-mp="23d0le33xoyxm">
              <div className="rounded-2xl bg-cream px-4 py-4" data-id="element-104" data-mp="239us0bo9vaw3">
                <p className="text-[12px] font-bold uppercase tracking-[0.1em] text-navy/50" data-id="element-105" data-mp="1ye5qw3wltlxo">
                  Esci dallo studio pensando:
                </p>
                <p className="mt-1.5 font-display text-[17px] font-bold italic leading-snug text-navy-deep" data-id="element-106" data-mp="2r1t9xei884i7">
                  “Spero di aver preso la decisione giusta.”
                </p>
              </div>
            </div>
          </div>

          {/* DOPO */}
          <div className="flex flex-col rounded-3xl border-2 border-kidney/40 bg-navy-deep p-5 sm:p-7" data-id="element-107" data-mp="2h5gg8gmolqng">
            <div className="flex items-center gap-2.5" data-id="element-108" data-mp="1al756bnvkdgf">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-kidney/20" data-id="element-109" data-mp="15n5kjmasw62u">
                <CheckIcon className="h-4 w-4 text-kidney-bright" aria-hidden="true" data-id="element-110" data-mp="vlbdevvy7aiu" />
              </span>
              <div data-id="element-111" data-mp="10k4uszecvloa">
                <p className="text-[10.5px] font-extrabold uppercase tracking-[0.16em] text-kidney-bright" data-id="element-112" data-mp="10jmn96m8tl12">
                  Con Percorso Malattia Renale™
                </p>
                <h3 className="font-display text-xl font-bold text-white sm:text-2xl" data-id="element-113" data-mp="1a9y5ly6obwrh">
                  Decidi seguendo un percorso chiaro
                </h3>
              </div>
            </div>

            <ul className="mt-5 flex flex-col gap-3.5" data-id="element-114" data-mp="1j8jibcpgshkc">
              {afterItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-115" data-mp="1oa8uwwsc53aj">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-kidney-bright" aria-hidden="true" data-id="element-116" data-mp="1t7qwu37xqi91" />
                  <span className="text-[14px] leading-relaxed text-white/85" data-id="element-117" data-mp="3q255a32ro73q">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-auto pt-6" data-id="element-118" data-mp="1p9jsncc6n7sz">
              <div className="rounded-2xl bg-white/[0.07] px-4 py-4" data-id="element-119" data-mp="1kc0fygv4v335">
                <p className="text-[12px] font-bold uppercase tracking-[0.1em] text-white/50" data-id="element-120" data-mp="1kbqlafz587r4">
                  Il risultato è semplice:
                </p>
                <p className="mt-1.5 font-display text-[17px] font-bold leading-snug text-kidney-bright" data-id="element-121" data-mp="1tcgedbx0rk15">
                  Il paziente si sente più sicuro. E anche tu.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-9 max-w-md sm:mt-12" data-id="element-122" data-mp="11jpgkwzotn9s">
          <CtaButton label="Voglio decidere con sicurezza" sub="+300 pagine cliniche • 6 volumi premium • 5 bonus • 100% digitale" data-id="element-123" data-mp="1fdp7a9gkqymi" />
        </div>
      </div>
    </section>;
}